import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next) // hooks
  .use({
    type: 'postProcessor',
    name: 'debug_missing_translation',
    process: (value) => "___DEBUG_" + value
  })
  .init({
    backend: {
      loadPath: `locales/{{lng}}/{{ns}}.json`,
    },
    fallbackLng: ['en'],
    load: 'languageOnly',

    // have a common namespace used around the full app
    ns: ['common'],
    defaultNS: 'common',

    debug: process.env.NODE_ENV === "development",

    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    postProcess: process.env.REACT_APP_DEBUG_TRANSLATION === "true" ? "debug_missing_translation" : ""
  });

export default i18n;